import { render, staticRenderFns } from "./MakhzonCost.vue?vue&type=template&id=1caa22e2&"
import script from "./MakhzonCost.vue?vue&type=script&lang=js&"
export * from "./MakhzonCost.vue?vue&type=script&lang=js&"
import style0 from "./MakhzonCost.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/projects/accurate/acc-dashboard/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VPagination } from 'vuetify/lib'
import { VSlideXReverseTransition } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
installComponents(component, {VAlert,VAutocomplete,VBtn,VContainer,VDataTable,VFlex,VLayout,VPagination,VSlideXReverseTransition,VToolbar})
